<template>
    <div>
        <base-modal :isOpen="isOpen" :title="$t('confirmation') | capitalize" @close="$emit('close')" size="sm">
            <!-- Body -->
            <template #body>
                <strong class="custom-dark">{{ message }}</strong>
            </template>
            <template #footer>
                <vs-button color="danger" type="border" @click="$emit('close')">
                    {{ $t('cancel') | capitalize }}
                </vs-button>
                <vs-button color="success" @click="$emit('accept',item)">
                    {{ $t('accept') | capitalize }}
                </vs-button>
            </template>
        </base-modal>
    </div>
</template>

<script>
import BaseModal from '@/views/app/components/modals/BaseModal.vue'
export default {
    name: 'ConfirmationModal',
    components: { BaseModal },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: () => ({})
        },
        message:{
            type:String,
            default() {
                return this.$t('delete_element_confirm')
            }

        }
    }
}
</script>

<style scoped>
::v-deep(.vs__dropdown-menu) {
    max-height: 50px;
    overflow-y: auto;
}
</style>
